const candidateTestingUrls = {
    startTesting: {
        url: '/testing-candidate/start'
    },
    tests: {
        url: '/testing-candidate/tests'
    },
    vote: {
        url: '/testing-candidate/vote'
    },
    finish: {
        url: '/testing-candidate/finish'
    },
    results: {
        url: '/testing-candidate/results'
    },
    testResults: {
        url: '/testing-candidate/testResults'
    },
    voteInfo: {
        url: '/testing-candidate/voteInfo'
    }
};
export default candidateTestingUrls;
